import React from "react";
import { useSelector } from "react-redux";
import { selectStatus } from "../features/user/userSlice";
import { Route, Redirect, useLocation } from "react-router-dom";

const PrivateRoute = (props) => {
	const location = useLocation();
	const authLogin = useSelector(selectStatus);

	return authLogin ? (
		<Route {...props} />
	) : (
		<Redirect
			to={{
				pathname: "/",
				state: { from: location },
			}}
		/>
	);
};

export default PrivateRoute;
